var cccApp = cccApp || {};

(function(app) {
    "use strict";

    //Public properties
    app.user = undefined;
    app.account = undefined;
    app.tier = undefined;
    app.computer = undefined;
    app.settings = {
        activityLogToken: undefined,
        handledErrorLogToken: undefined,
        unhandledErrorLogToken: undefined,
        whitelist: ["agomo.com", "ccleaner.com", "ccleanercloud.com", "dropbox.com", "braintree", "intercom", "visualwebsiteoptimizer.com", "knockout"],
        cdnroot: "/resources/dist/",
        cdn: "/resources/dist/",
        braintreeClientToken: undefined,
        intercomAppId: undefined,
        zendeskUrl: undefined
    };
    app.connectivity = undefined;
    app.session = undefined;
    app.clientSystem = {};
    app.models = {};

    app.header = undefined;

    //Private methods
    function detectClientSystem() {

        var unknown = "-";

        // screen
        var screenSize = "";
        var width = 0;
        var height = 0;

        if (screen.width) {
            width = screen.width ? screen.width : "";
            height = screen.height ? screen.height : "";
            screenSize += "" + width + " x " + height;
        }

        // browser
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browser = navigator.appName;
        var version = "" + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;
        var language = typeof navigator.language !== "undefined" ? navigator.language : "NULL";


        // Opera
        if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
            browser = "Opera";
            version = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf("Version")) !== -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // Opera Next
        if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
            browser = "Opera";
            version = nAgt.substring(verOffset + 4);
        }
            // MSIE
        else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
            browser = "Internet Explorer";
            version = nAgt.substring(verOffset + 5);
        }
            // Edge
        else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
            browser = "Microsoft Edge";
            version = nAgt.substring(verOffset + 5);
        }
            // Chrome
        else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
            browser = "Chrome";
            version = nAgt.substring(verOffset + 7);
        }
            // Safari
        else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
            browser = "Safari";
            version = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf("Version")) !== -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
            // Firefox
        else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
            browser = "Firefox";
            version = nAgt.substring(verOffset + 8);
        }
            // MSIE 11+
        else if (nAgt.indexOf("Trident/") !== -1) {
            browser = "Internet Explorer";
            version = nAgt.substring(nAgt.indexOf("rv:") + 3);
        }
            // Other browsers
        else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);
            if (browser.toLowerCase() === browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        if ((ix = version.indexOf(";")) !== -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(" ")) !== -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(")")) !== -1) version = version.substring(0, ix);

        majorVersion = parseInt("" + version, 10);
        if (isNaN(majorVersion)) {
            version = "" + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // cookie
        var cookieEnabled = navigator.cookieEnabled ? true : false;

        if (typeof navigator.cookieEnabled === "undefined" && !cookieEnabled) {
            document.cookie = "testcookie";
            cookieEnabled = (document.cookie.indexOf("testcookie") !== -1);
        }

        // system
        var os = unknown;
        var clientStrings = [
            { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
            { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
            { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
            { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
            { s: "Windows Vista", r: /Windows NT 6.0/ },
            { s: "Windows Server 2003", r: /Windows NT 5.2/ },
            { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
            { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
            { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
            { s: "Windows 98", r: /(Windows 98|Win98)/ },
            { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
            { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
            { s: "Windows CE", r: /Windows CE/ },
            { s: "Windows 3.11", r: /Win16/ },
            { s: "Android", r: /Android/ },
            { s: "Open BSD", r: /OpenBSD/ },
            { s: "Sun OS", r: /SunOS/ },
            { s: "Linux", r: /(Linux|X11)/ },
            { s: "iOS", r: /(iPhone|iPad|iPod)/ },
            { s: "Mac OS X", r: /Mac OS X/ },
            { s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
            { s: "QNX", r: /QNX/ },
            { s: "UNIX", r: /UNIX/ },
            { s: "BeOS", r: /BeOS/ },
            { s: "OS/2", r: /OS\/2/ },
            { s: "Search Bot", r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
        ];

        for (var id in clientStrings) {
            if (clientStrings.hasOwnProperty(id)) {
                var cs = clientStrings[id];
                if (cs.r.test(nAgt)) {
                    os = cs.s;
                    break;
                }

            }
        }

        var osVersion = unknown;

        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os)[1];
            os = "Windows";
        }

        switch (os) {
            case "Mac OS X":
                osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
                break;

            case "Android":
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                break;

            case "iOS":
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                osVersion = osVersion[1] + "." + osVersion[2] + "." + (osVersion[3] | 0);
                break;
        }

        var window = undefined;

        app.clientSystem = {
            browser: browser,
            browserVersion: version,
            browserMajorVersion: majorVersion,
            os: os,
            osVersion: osVersion,
            mobile: mobile,
            lang: language,
            screen: screenSize,
            window: window
        };
    }

    function initializeErrorReporting() {

        if (!app.settings) {
            return;
        }

        var handledErrorLogToken = app.settings.handledErrorLogToken;
        var unhandledErrorLogToken = app.settings.unhandledErrorLogToken;

        if (typeof handledErrorLogToken !== "undefined" && handledErrorLogToken !== null && handledErrorLogToken !== "") {
            LE.init({ name: "handled", token: handledErrorLogToken });
        }

        //Only initialise if you have a log entries token to initialise with 
        if (typeof unhandledErrorLogToken !== "undefined" && unhandledErrorLogToken !== null && unhandledErrorLogToken !== "") {

            LE.init({ name: "unhandled", token: unhandledErrorLogToken });

            initializeErrorWhiteList();

            if (typeof window.onerror !== "function") {
                window.onerror = function (message, file, line, col, errorObj) {

                    var isInWhiteList = false;

                    if (app.settings) {
                        if (!app.settings.whitelist) {
                            initializeErrorWhiteList();
                        }

                        //Check Whiteist for scripts we want to log
                        for (var i = 0; i < app.settings.whitelist.length; i++) {
                            if (file.indexOf(app.settings.whitelist[i]) > -1) {
                                isInWhiteList = true;
                                break;
                            }
                        }
                    }

                    if (!isInWhiteList) {
                        return;
                    }

                    var appName = "NULL";
                    var fullUrl = "NULL";
                    if (window.location) {
                        fullUrl = window.location.href;
                        appName = window.location.host;
                    }

                    try {
                        if (LE.to("unhandled")) {
                            LE.to("unhandled").error({
                                app: appName,
                                url: fullUrl,
                                s: app.clientSystem,
                                e: {
                                    message: message,

                                    file: (typeof file !== "undefined" && file !== null) ? file : "NULL",
                                    line: (typeof line !== "undefined" && line !== null) ? line : 0,
                                    col: (typeof col !== "undefined" && col !== null) ? col : 0,
                                    stack: (typeof errorObj !== "undefined" && errorObj !== null) ? errorObj.stack : "NULL"
                                }
                            });
                        }
                    } catch (e) {
                        //Do Nothing
                    }
                };
            }

            if (typeof requirejs !== "undefined" && typeof requirejs.onError !== "function") {
                requirejs.onError = function (err) {
                    logRequireError("", false, "Sorry, there was a problem while loading this tab", "global-messages", err, {});
                };
            }
        }
    }

    function initializeActivityLogging() {

        if (!app.settings) {
            return;
        }

        var activityLogToken = app.settings.activityLogToken;

        //Only initialise if you have a log entries token to initialise with 
        if (typeof activityLogToken !== "undefined" && activityLogToken !== null && activityLogToken !== "") {
            LE.init({ name: "activity", token: activityLogToken });
        }
    }

    function initializeErrorWhiteList() {
        if (typeof app.settings !== "undefined") {
            app.settings.whitelist = ["agomo.com", "ccleaner.com", "ccleanercloud.com", "dropbox.com", "braintree", "intercom", "visualwebsiteoptimizer.com", "knockout"];
        }
    }

    function initializeWindowSize() {
        if (!app.clientSystem.window) {
            app.clientSystem.window = new WindowSize(window.innerWidth, window.innerHeight);
            $(window).on("resize", function() {
                app.clientSystem.window.width(window.innerWidth);
                app.clientSystem.window.height(window.innerHeight);
                app.clientSystem.window.triggerResizeCallbacks();
            }).resize();
        }
    }

    //Public methods
    app.init = function(appData) {
        
        app.settings = {
            serverUTCTime: appData.serverUTCTime || undefined,
            braintreeClientToken: appData.appSettings && appData.appSettings.braintreeClientToken ? appData.appSettings.braintreeClientToken : undefined,
            intercomAppId: appData.appSettings && appData.appSettings.intercomAppId ? appData.appSettings.intercomAppId : undefined,
            zendeskUrl: appData.appSettings && appData.appSettings.zendeskUrl ? appData.appSettings.zendeskUrl : undefined,
            paypalEnabled: appData.appSettings && appData.appSettings.paypalEnabled ? appData.appSettings.paypalEnabled : false,
            activityLogToken: appData.activityLoggingToken ? appData.activityLoggingToken : undefined,
            handledErrorLogToken: appData.handledErrorLoggingToken ? appData.handledErrorLoggingToken : undefined,
            unhandledErrorLogToken: appData.unhandledErrorLoggingToken ? appData.unhandledErrorLoggingToken : undefined,
            whitelist: ["agomo.com", "ccleaner.com", "ccleanercloud.com", "dropbox.com", "braintree", "intercom", "visualwebsiteoptimizer.com"],
            iconServer: appData.appSettings && appData.appSettings.iconServer ? appData.appSettings.iconServer : undefined,
            showRecaptcha: appData.appSettings && appData.appSettings.showRecaptcha ? appData.appSettings.showRecaptcha : false
        };

        if (appData.appSettings && appData.appSettings.isDebugMode) {
            app.settings.isDebugMode = appData.appSettings.isDebugMode;
        }

        cccApp.dates.initializeMoment(app.user);

        detectClientSystem();
        initializeErrorReporting();
        initializeActivityLogging();
        initializeWindowSize();

        app.connectivity = new Connectivity();
        app.user = appData.user ? new User(appData.user) : undefined;
        app.account = appData.account ? new UserAccount(appData.account) : undefined;
        app.tier = appData.tier ? new Tier(appData.tier) : undefined;
        app.computer = appData.computer ? new Computer(appData.computer) : undefined;
        app.header = new SiteHeader(app.user && app.user.loggedIn ? true : false);

        if (app.account) {
            app.account.init();
        }

        var logoutPopup = $("#logout-popup");
        if (logoutPopup.length > 0) {
            app.session = new LoginSession();
            ko.applyBindings(app.session, logoutPopup[0]);
        }

        if (app.clientSystem) {
            if (app.clientSystem.browser === "Internet Explorer") {
                $("body").addClass("ie");

                switch (app.clientSystem.browserMajorVersion) {
                    case 8:
                        $("body").addClass("ie8");
                        break;
                    case 9:
                        $("body").addClass("ie9");
                        break;
                }
            }

            if (app.clientSystem.browser === "Microsoft Edge") {
                $("body").addClass("edge");
            }
        }

        var tabQueueContainer = $("#main-content");
        if (tabQueueContainer.length > 0) {
            tabQueueContainer.queue("tab-nav", []);
        }

        if (typeof app !== "undefined") {
            var el = document.getElementsByTagName("header");

            if (el && el.length > 0) {
                ko.applyBindings(app, el[0]);
            }
        }

        if (moment) {
            //Reset Moment default text
            moment.updateLocale("en", {
                relativeTime: {
                    future: "in %s",
                    past: "%s",
                    s: "Just now",
                    ss: "%s seconds ago",
                    m: "%d minute ago", //change that to "%d minute"
                    mm: "%d minutes ago",
                    h: "1 hour ago", //here too
                    hh: "%d hours ago",
                    d: "1 day ago", //and here
                    dd: "%d days ago",
                    M: "1 month ago", //and so on...
                    MM: "%d months ago",
                    y: "1 year ago",
                    yy: "%d years ago"
                }
            });
        }

        if ($.featherlight && $.featherlight.prototype) {
            $.featherlight.prototype.closeIcon = "";
        }
    };

    app.openPopup = function(id, popupConfig, isShared) {

        if ($.featherlight) {

            isShared = (typeof isShared !== "undefined" && isShared !== null) ? isShared : true;

            popupConfig = popupConfig || {};

            if (isShared) {
                popupConfig["persist"] = true;
            }

            var movePopup = function () {
                $("#" + id).appendTo($("#main-content"));
            };

            var config = $.extend(true, {}, popupConfig);

            if (popupConfig.beforeClose) {
                var beforeCloseEvent = function (event) {
                    movePopup.apply(this, arguments);
                    popupConfig.beforeClose(event);
                };

                config["beforeClose"] = beforeCloseEvent;
            } else {
                config["beforeClose"] = movePopup;
            }

            $.featherlight("#" + id, config);
        } else {
            logError("Open Popup", false, {
                "error": "Featherlight is not initialized",
                "element-id": id,
                "config": JSON.stringify(popupConfig)
            });
            cccApp.msg.error("Sorry, there was a problem displaying this popup. Please refresh the page and try again", undefined, true);
        }
    };

    app.closePopup = function() {
        if ($.featherlight) {
            $.featherlight.close();
        } else {
            logError("Close Popup", false, {
                "error": "Featherlight is not initialized"
            });
        }
    };

    app.openContactUsPopup = function(option, logAction) {

        option = typeof option === "number" ? option : cccApp.enums.contactUsTypes.SalesEnquiry;
        logAction = logAction || "Contact Us Popup Click";

        cccApp.closePopup();

        logActivity(logAction);

        function onPopupRender(viewModel) {
            viewModel.reset();
            viewModel.selectedOption(option);
        }

        loadPopup(ko, "contact-us-popup", { render: onPopupRender }, logAction);
    };

    app.copyViewModel = function(objFrom, objTo) {
        if(typeof objFrom === "object" && typeof objTo === "object") {
            ko.mapping.fromJS(ko.mapping.toJS(objFrom), {}, objTo);
            return objTo;
        }

        return null;
    };

    app.setClipboardText = function(text, containerElement) {
        var successful;
        var selection;
        var range = document.createRange();

        // For IE
        if (window.clipboardData) {
            window.clipboardData.setData("Text", text);
            successful = true;
        } else {
            var tmpElement = $('<div>');

            tmpElement.css({
                position: "absolute",
                left: "-1000px",
                top: "-1000px"
            });

            tmpElement.text(text);

            if (containerElement) {
                $(containerElement).append(tmpElement);
            } else {
                $("body").append(tmpElement);
            }

            range.selectNodeContents(tmpElement.get(0));
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            try {
                successful = document.execCommand("copy");
            } catch (e) {
                successful = false;
            }
        }

        return successful;
    };

    return app;

})(cccApp);